export default __webpack_public_path__ + "static/media/mountain-1.4929722a.jpg";